/* eslint-disable max-lines */
import {
    ListForImportGoodsByShopTypeUsingGetParams,
    GylErpShopInfo,
    ExportOnlineGoodsParam,
    UpsertOnlineGoodsUsingGetParams,
    UpdateOnlineStyleCodeUsingGetParams,
    BatchUpdateOnlinePriceVo,
    QueryTaskUsingGet3Params,
    RedisProgressInfo,
    SaveJobParam,
    GoOnlineModifyPriceItem,
    QueryUpToDateResult,
    QueryOnlineItemVo,
    GoGoodsOnlineItem,
    ImportLogQueryParam,
    GoGoodsImport,
    LoadGylCategoryUsingGetParams,
    GylCategory,
    SyncOnlineItemsUsingGetParams,
    OnlineItemImportVo,
    GetProcessUsingGet3Params,
    ExcelImportStatus,
    QueryImportDetailListUsingGetParams,
    GoodsImportDetail,
    LoadUsingGet2Params,
    GoodsImportLoad,
    GetShopUpdateRecordUsingGetParams,
    ShopChangeRecord,
    GetSyncProcessUsingGetParams,
    ShopSyncProcess,
    StyleCodeCheckVo,
    StyleCodeCheckResult,
    QueryImportDetailTagUsingGetParams,
    QueryImportDetailTag,
    OnlineItemErpStatusVo,
    ExcelTipsInfo,
    ShopSpuItemParam,
    ShopSpuItemImport,
    ImportUpdateVo,
    QuerySupplierShopSpuCountForImportUsingGetParams,
    SupplierShopSpuParam,
    SupplierShopSpuResult,
    QueryOnlineGoodsListParam,
    AbstractSupplierShopOnlineSpuItem,
    UpsertMulitPlatformParam,
    ItemCheckInMallParam,
    ItemInMalResultVo,
    ItemPriceCheckParam,
    QueryItemPriceCheckResultUsingGetParams,
    ItemCheckPriceResult,
    CheckPddShopItemNumUsingGetParams,
    ShopManageSpuQueryVo,
    ShopItemSpuVo,
    ClientTokenQueryParam,
    ClientTokenResult,
    DiagnoseQueryParam,
    TaoDiagnoseVo,
    ShopManageSkuQueryVo,
    ShopItemSkuVo,
    SyncShopSkuStockVo,
    SyncShopSpuStockVo,
    StockSyncStatusParam,
    ChangeSkuSyncResult,
    GetShopTrusteeshipConfigConditionUsingGetParams,
    ShopTrusteeshipConfigCondition,
    OnlineItemShelvesInfoParam,
    OnlineItemShelvesInfoResult,
    ShopItemImportParam,
    ShopItemImportResult,
    ShopManageSkuStockSyncParam,
    ShopItemSkuStockSync,
    QueryShopSpuStockInfoParam,
    ShopSpuStockInfo,
    SpuStockSyncStatusParam,
    ColorSpecItemCodeVo
} from '@servicesTypings/goodsRequest'
import { getCacheService, postCacheService } from '@/utils/requestUtils'

import { goodsRequest } from '@/utils/request'

// 查询线上店铺
/**
 * 根店铺类型查询可导入商品的店铺列表
 */
export function getErpShops(params: ListForImportGoodsByShopTypeUsingGetParams): API.Res<GylErpShopInfo[]> {
    return goodsRequest.get('/erpShopInfo/listForImportGoodsByShopType', { params })
}

// 导出线上商品
/**
 * 导出线上商品编码信息
 */
export function exportOnlineOnlineGoods(data: ExportOnlineGoodsParam): API.Res<string> {
    return goodsRequest.post('/online/goods/exportOnlineOnlineGoods', { data })
}

// 导出线上商品款式编码
/**
 * 导出线上款式编码信息
 */
export function exportOnlineGoodsStyleInfo(data: ExportOnlineGoodsParam): API.Res<string> {
    return goodsRequest.post('/online/goods/exportOnlineGoodsStyleInfo', { data })
}

// 导入更新线上商品
/**
 * 导入更新线上商品信息
 */
export function upsertOnlineGoods(params: UpsertOnlineGoodsUsingGetParams): API.Res<string> {
    return goodsRequest.get('/online/goods/upsertOnlineGoods', { params })
}

// 导入更新线上商品款式编码
/**
 * 导入更新线上商品款式信息
 */
export function updateOnlineStyleCode(params: UpdateOnlineStyleCodeUsingGetParams): API.Res<string> {
    return goodsRequest.get('/online/goods/updateOnlineStyleCode', { params })
}

// 获取导入模板
/**
 * 下载同步店铺价格导入模板
 */
export function downloadUpdatePriceTpl(): API.Res<string> {
    return goodsRequest.get('/online/goods/downloadUpdatePriceTpl')
}

// 解析导入更新线上商品价格Excel
/**
 * 导入更新线上商品价格Excel
 */
export function analysisUpdateOnlinePrice(data: BatchUpdateOnlinePriceVo): API.Res<string> {
    return goodsRequest.post('/online/goods/analysisUpdateOnlinePrice', { data })
}

// 获取任务进度
/**
 * 获取单个商品信息
 */
export function queryTask(params: QueryTaskUsingGet3Params): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/online/goods/queryTask', { params })
}

// 根据任务ID获取sku列表
export function queryOnlineSkuList(data) {
    const queryOnlineSku = postCacheService(goodsRequest)
    return queryOnlineSku.post('/online/goods/queryOnlineSkuList', {
        data
    })
}
// 保存任务
/**
 * 保存任务
 */
export function saveJob(data: SaveJobParam[]): API.Res<object> {
    return goodsRequest.post('/online/goods/saveJob', { data })
}

// 保存任务并执行
/**
 * 保存任务并执行
 */
export function saveJobAndExecute(data: SaveJobParam[]): API.Res<string> {
    return goodsRequest.post('/online/goods/saveJobAndExecute', { data })
}

// 执行任务
/**
 * 价格修改任务执行
 */
export function executeModifyPriceJob(data: GoOnlineModifyPriceItem): API.Res<string> {
    return goodsRequest.post('/online/goods/executeModifyPriceJob', { data })
}

// 导入更新线上商品款式编码
/**
 * 查询最新的任务信息
 */
export function queryUpToDateTask(): API.Res<QueryUpToDateResult> {
    return goodsRequest.get('/online/modifyPrice/queryUpToDateTask')
}

// 获取线上店铺商品
/**
 * 获取用户店铺线上商品列表
 */
export function queryOnlineShopGoods(data: QueryOnlineItemVo): API.Res<GoGoodsOnlineItem[]> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/getOnlineShopGoods', { data })
}

// 查询导入日志
/**
 * 查询商品导入日志列表(POST请求)
 */
export function queryShopGoodsImportList(data: ImportLogQueryParam): API.Res<GoGoodsImport[]> {
    return goodsRequest.post('/goods/goGoodsImport/queryImportGoodsList', { data })
}

// 获取类目
/**
 * 根据店铺查询类目树
 */
export function queryCategory(params: LoadGylCategoryUsingGetParams): API.Res<GylCategory[]> {
    return goodsRequest.get('/supplier/goGoodsOnlineItem/loadGylCategory', { params })
}

// 更新数据
/**
 * 同步淘系店铺线上店铺商品数据
 */
export function asyncOnlineGoods(params: SyncOnlineItemsUsingGetParams): API.Res<object> {
    return goodsRequest.get('/supplier/goGoodsOnlineItem/syncOnlineItems', { params })
}

// 批量导入
/**
 * 线上店铺商品导入
 */
export function onlineItemImportBatch(data: OnlineItemImportVo): API.Res<object> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/onlineItemImport', { data })
}

// 批量导入进度
/**
 * 获取进度条
 */
export function getProcess(params: GetProcessUsingGet3Params): API.Res<ExcelImportStatus> {
    return goodsRequest.get('/supplier/goGoodsOnlineItem/getProcess', { params })
}

/**
 * 查询商品导入明细列表
 */
export function queryImportDetailList(params: QueryImportDetailListUsingGetParams): API.Res<GoodsImportDetail[]> {
    return goodsRequest.get('/goods/goGoodsImportSpuDetail/queryImportDetailList', { params })
}

// 加载导入日志详情
/**
 * 加载商品导入日志详情
 */
export function loadShopImportDetail(params: LoadUsingGet2Params): API.Res<GoodsImportLoad> {
    return goodsRequest.get('/goods/goGoodsImport/load', { params })
}

// 获取店铺的是否缓存同步信息 (NEW 2020-03-25)
/**
 * 线上店铺商品上一次同步时间
 */
export function getShopUpdateRecord(params: GetShopUpdateRecordUsingGetParams): API.Res<ShopChangeRecord> {
    return goodsRequest.get('/goods/shopChangeRecord/getShopUpdateRecord', { params })
}

// 查询店铺的同步进度 (NEW 2020-03-25)
/**
 * 店铺是否正在同步线上商品
 */
export function getSyncProcess(params: GetSyncProcessUsingGetParams): API.Res<ShopSyncProcess> {
    return goodsRequest.get('/goods/shopChangeRecord/getSyncProcess', { params })
}

// 选择的商品中是否有重复 (NEW 2020-03-25)
/**
 * 查询选中款号是否存在重复
 */
export function checkRepeatStyleCode(data: StyleCodeCheckVo): API.Res<StyleCodeCheckResult> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/checkRepeatStyleCode', { data })
}

// 查询导入日志明细，标签上的数量
/**
 * 查询商品导入列表标签
 */
export function queryImportDetailTagImport(params: QueryImportDetailTagUsingGetParams): API.Res<QueryImportDetailTag> {
    return goodsRequest.get('/goods/goGoodsImportSpuDetail/queryImportDetailTag', { params })
}

// 查询线上平台商品资料(查询选中商品是否存在于ERP)
/**
 * 查询选中商品是否存在于ERP
 */
export function checkOnlineItemErpStatus(data: OnlineItemErpStatusVo): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/checkItemErpStatus', { data })
}

// 查询线上关联商品
/**
 * 查看线上关联商品
 */
export function queryShopSpuForImport(data: ShopSpuItemParam): API.Res<ShopSpuItemImport[]> {
    return goodsRequest.post('/shop/shopSpu/queryShopSpuForImport', { data })
}

// 导入更新更新线上关联商品 （单个、批量）
/**
 * 线上店铺商品导入更新
 */
export function importUpdateOnlineItem(data: ImportUpdateVo): API.Res<string> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/importUpdate', { data })
}

// 查看供应商店铺商品关联款信息数量
/**
 * 查看供应商店铺商品关联款信息数量
 */
export function querySupplierShopSpuCountForImport(
    params: QuerySupplierShopSpuCountForImportUsingGetParams
): API.Res<number> {
    return goodsRequest.get('/supplier/shopManage/querySupplierShopSpuCountForImport', { params })
}

// 查看供应商店铺商品关联款信息
/**
 * 查看供应商店铺商品关联款信息
 */
export function querySupplierShopSpuForImport(data: SupplierShopSpuParam): API.Res<SupplierShopSpuResult[]> {
    return goodsRequest.post('/supplier/shopManage/querySupplierShopSpuForImport', { data })
}

// 根据供应商的线上商品信息新增或修改平台资料
/**
 * 查询供应商店铺商品关联款信息的线上类目属性信息
 */
export function querySupplierShopSpuOnlineCateData(
    data: QueryOnlineGoodsListParam
): API.Res<AbstractSupplierShopOnlineSpuItem[]> {
    return goodsRequest.post('/supplier/shopManage/querySupplierShopSpuOnlineCateData', { data })
}

// 根据供应商的线上商品信息新增或修改平台资料
/**
 * 根据供应商的线上商品信息新增或修改平台资料V2
 */
export function upsertPlatformBySupplierOnlineGoodsV2(data: UpsertMulitPlatformParam): API.Res<string> {
    return goodsRequest.post('/supplier/shopManage/upsertPlatformBySupplierOnlineGoodsV2', { data })
}

// 商品是否已加入分销小站
/**
 * 商品是否已加入分销小站
 */
export function checkInDrpMall(data: ItemCheckInMallParam): API.Res<ItemInMalResultVo[]> {
    return goodsRequest.post('/drpMallOnlineItem/checkInDrpMall', { data })
}

// 查询线上商品是否有基本售价
/**
 * 查询线上商品是否有基本售价
 */
export function queryOnlineItemCheckPrice(data: ItemPriceCheckParam): API.Res<string> {
    return goodsRequest.post('/drpMallOnlineItem/queryOnlineItemCheckPrice', { data })
}

// 查询线上商品校验是否有基本售价结果
/**
 * 查询线上商品校验是否有基本售价结果
 */
export function queryItemPriceCheckResult(
    params: QueryItemPriceCheckResultUsingGetParams
): API.Res<ItemCheckPriceResult> {
    return goodsRequest.get('/drpMallOnlineItem/queryItemPriceCheckResult', { params })
}

/**
 * 校验商家店铺商品数是否超过1W款
 */
/**
 * 校验商家店铺商品数是否超过1W款
 */
export function checkPddShopItemNum(params: CheckPddShopItemNumUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/supplier/goGoodsOnlineItem/checkPddShopItemNum', { params })
}

/**
 * 校验商家店铺商品数是否超过1W款
 */
export function checkDyShopItemNum(params: CheckPddShopItemNumUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/supplier/goGoodsOnlineItem/checkDouyinShopItemNum', { params })
}

/**
 * 店铺商品管理按款列表
 */
/**
 * 店铺商品管理按款列表
 */
export function queryShopItemSpuList(data: ShopManageSpuQueryVo): API.Res<ShopItemSpuVo[]> {
    return goodsRequest.post('/shopManage/queryShopItemSpuList', { data })
}

/**
 * 获取多个店铺的secToken
 */
export function querySecToken(data) {
    return getCacheService(goodsRequest).post('/shelves/taobao/v3/querySecToken', {
        data
    })
}

/**
 * 获取多个店铺的clientToken
 */
/**
 * 获取多个店铺的clientToken
 */
export function queryClientToken(data: ClientTokenQueryParam[]): API.Res<ClientTokenResult[]> {
    return goodsRequest.post('/shelves/taobao/v3/queryClientToken', { data })
}

/**
 * 获取淘宝质量分列表
 */
/**
 * 获取淘宝质量分列表
 */
export function getItemDiagnoseList(data: DiagnoseQueryParam): API.Res<TaoDiagnoseVo[]> {
    return goodsRequest.post('/shelves/taobao/v3/getItemDiagnoseList', { data })
}

/**
 * 店铺商品管理按款列表
 */
/**
 * 店铺商品管理按sku列表
 */
export function queryShopItemSkuList(data: ShopManageSkuQueryVo): API.Res<ShopItemSkuVo[]> {
    return goodsRequest.post('/shopManage/queryShopItemSkuList', { data })
}

/**
 * 触发店铺商品链接库存同步
 */
/**
 * 触发店铺商品链接库存同步
 */
export function syncShopSkuStock(data: SyncShopSkuStockVo): API.Res<object> {
    return goodsRequest.post('/shopManage/syncShopSkuStock', { data })
}

/**
 * 触发店铺商品按款库存同步
 */
/**
 * 触发店铺商品按款库存同步
 */
export function syncShopSpuStock(data: SyncShopSpuStockVo[]): API.Res<object> {
    return goodsRequest.post('/shopManage/syncShopSpuStock', { data })
}

/**
 * 修改店铺商品SKU库存同步状态
 */
/**
 * 修改店铺商品SKU库存同步状态
 */
export function changeShopSkuSyncStatus(data: StockSyncStatusParam): API.Res<ChangeSkuSyncResult> {
    return goodsRequest.post('/shopManage/changeShopSkuSyncStatus', { data })
}

//   获取导入时,店铺托管配置条件
/**
 * 获取导入时,店铺托管配置条件
 */
export function getShopTrusteeshipConfigCondition(
    params: GetShopTrusteeshipConfigConditionUsingGetParams
): API.Res<ShopTrusteeshipConfigCondition> {
    return goodsRequest.get('/supplier/goGoodsOnlineItem/getShopTrusteeshipConfigCondition', { params })
}

// 查询线上商品铺货信息
/**
 * 查询线上商品铺货信息
 */
export function queryOnlineItemShelvesInfo(data: OnlineItemShelvesInfoParam): API.Res<OnlineItemShelvesInfoResult> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/queryOnlineItemShelvesInfo', { data })
}

// 查询线上商品铺货信息 cacheId (缓存)
/**
 * 快速铺货保存参数
 */
export function queryOnlineItemShelvesInfoCache(
    data: OnlineItemShelvesInfoParam
): API.Res<OnlineItemShelvesInfoResult> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/preShelvesParam', { data })
}

// 导入店铺商品（简化版）
// 仅用在店铺商品的
/**
 * 店铺商品导入
 */
export function shopItemImport(data: ShopItemImportParam): API.Res<ShopItemImportResult> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/shopItemImport', { data })
}

// 批量查询店铺商品最新库存同步记录
/**
 * 店铺商品最新库存同步记录查询
 */
export function queryShopItemStockSync(data: ShopManageSkuStockSyncParam[]): API.Res<ShopItemSkuStockSync[]> {
    return goodsRequest.post('/shopManage/queryShopItemStockSync', { data })
}

// 查询店铺商品款的库存信息
/**
 * 查询店铺商品款的库存信息
 */
export function queryShopItemSpuStockInfo(data: QueryShopSpuStockInfoParam[]): API.Res<ShopSpuStockInfo[]> {
    return goodsRequest.post('/shopManage/queryShopItemSpuStockInfo', { data })
}

// 修改店铺商品SPU库存同步状态
/**
 * 修改店铺商品SPU库存同步状态
 */
export function changeShopSpuSyncStatus(data: SpuStockSyncStatusParam): API.Res<string> {
    return goodsRequest.post('/shopManage/changeShopSpuSyncStatus', { data })
}

/**
 * 当前商家是否是大店商家
 */
/**
 * 是否是供应商线上店铺导入白名单
 */
export function isFreshmanCompany(): API.Res<boolean> {
    return goodsRequest.get('/supplier/shopManage/isSupplierOnlineShopImportWhitelist')
}

/**
 * 查询sku颜色规格商品编码
 */
/**
 * 查询sku颜色规格商品编码
 */
export function querySkuColorSpecItemCode(data: SupplierShopSpuParam): API.Res<ColorSpecItemCodeVo[]> {
    return goodsRequest.post('/supplier/shopManage/querySkuColorSpecItemCode', { data })
}

/**
 * 获取缺失系统商品数量
 */
export function getMissingCountUsingGET(): API.Res<number> {
    return goodsRequest.get('/shopManage/getMissingCount')
}

/**
 * 查询自动替换系统商品开关
 */
export function queryAutoMappingConfigUsingGET(): API.Res<any> {
    return goodsRequest.get('/shopManage/queryAutoMappingConfig')
}

/**
 * 更新自动替换系统商品开关
 */
export function updateAutoMappingConfigUsingPOST(data: object): API.Res<boolean> {
    return goodsRequest.post('/shopManage/updateAutoMappingConfig', { data })
}
